import { fetchAllMessageLogs } from 'components/domain/automation/messageLogs/messageLogsQuery';
import FilterFormContextSearchField from 'components/filters/FilterFormContextSearchField';
import { SearchOption } from 'components/filters/FilterFormContextSearchField.styles';
import useFilterFormContext from 'components/filters/useFilterFormContext';
import useAppMutation from 'hooks/useAppMutation';

const MessageLogSearchField = () => {
  const { searchFieldRef } = useFilterFormContext();
  const { mutateAsync: searchMessageLogs } = useAppMutation({
    mutationFn: fetchAllMessageLogs,
  });

  const searchHandler = async (query: string) => {
    const data = await searchMessageLogs({ messageName: query });
    return data.triggerLogs;
  };

  return (
    <FilterFormContextSearchField
      containerClassName="search-field"
      labelKey={(option) => `${option.messageName ?? ''}`}
      name="messageLogSearch"
      instanceRef={searchFieldRef}
      renderMenuItemChildren={(option) => (
        <SearchOption data-testid={`found-message-log-${option.messageUid}`}>
          {option.messageName}
        </SearchOption>
      )}
      searchHandler={searchHandler}
    />
  );
};

export default MessageLogSearchField;
